<script setup lang="ts"></script>

<template>
  <icon name="lucide:minus" />
</template>

<style scoped></style>
